import { theme } from 'Assets/Styles/theme'

export const styles = {
  wrapper: { padding: '2.5rem', margin: '2rem 0px' },
  title: {
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& > div:nth-child(2) > table': {
      cursor: 'initial',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '20px',
  },
  addButton: {
    cursor: 'pointer',
    pointerEvents: 'all' /* or just ensure 'none' isn't applied */,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.colors.primary,
    borderRadius: '4px',
    height: 40,
    width: 40,
    marginRight: 10,
    fontSize: 20,
    filter: 'brightness(1)',
    '&:hover': {
      filter: 'brightness(1.3)',
    },

    '& > div': {
      color: '#FFFFFF',
    },
  },
  buttonLabel: {
    fontSize: 16,
    color: theme.colors.primary,
  },
  link: { '&:hover': { textDecoration: 'underline' } },
}
